export interface FaqDto
{
    getFaqQuestion(): string;
    getFaqAnswer():string;
    getFaqAnswerHeader():string;
    getFaqDataList():FaqDataListDto[];
}

export class FaqDataListDto
{
    private data: FaqDataDto[];

    setData(data: FaqDataDto[])
    {
        this.data = data;
    }

    getData(): FaqDataDto[]
    {
        return this.data;
    }
}

export class FaqDataDto 
{
    private text: string;
    private style: object;

    setText(text: string)
    {
        this.text = text;
    }

    setStyle(style: object)
    {
        this.style = style;
    }

    getText(): string
    {
        return this.text;
    }

    getStyle(): object
    {
        return this.style;
    }
}
export class FaqDtoImpl implements FaqDto
{
    private faqQuestion: string;
    private faqAnswer: string;
    private faqHeader:string;
    private dataList: FaqDataListDto[];

    getFaqQuestion(): string 
    {
        return this.faqQuestion;
    }
    setFaqQuestion(faqQuestion: string)
    {
        this.faqQuestion = faqQuestion;
    }

    setFaqAnswerHeader(faqHeader:string):void{
        this.faqHeader = faqHeader;
    }
    getFaqAnswerHeader():string{
        return this.faqHeader;
    }
    getFaqAnswer(): string
    {
        return this.faqAnswer;
    }
    setFaqAnswer(faqAnswer: string)
    {
        this.faqAnswer = faqAnswer;
    }

    setFaqDataList(datalist: FaqDataListDto[])
    {
        this.dataList = datalist;
    }

    getFaqDataList(): FaqDataListDto[]
    {
        return this.dataList;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/faq/faqdto.tsx